/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { Injectable } from '@angular/core';

/**
 * @export
 * @class UtilService
 */
@Injectable()
export class UtilService {

    /**
     * This method deep cloning  the object
     * @param {*} object
     * @returns
     * @memberOf UtilService
     */
    deepClone(object: any) {
        return JSON.parse(JSON.stringify(object));
    }

    /**
     * This is used to generate uunique id
     * @returns
     * @memberOf UtilService
     */
    generateUniqueId(i?: number) {
        return new Date().getTime() + (i ? i : 0);
    }

    /**
     * This is used to check whether object is empty or not
     * @param {*} object
     * @returns
     * @memberOf UtilService
     */
    isEmptyObject(object: any) {
        return !object || (Object.keys(object).length === 0);
    }

    /**
     * @param {any} dragIndex
     * @param {any} dropIndex
     * @param {any} arrItems
     * @param {any} [selectedlocomotives]
     * @returns
     *
     * @memberOf UtilService
     */
    shift(dragIndex, dropIndex, arrItems, selectedlocomotives?) {
        this.printArrayTemp(arrItems);
        let newArrayItems = [];
        let alertIndex = [];
        if (dragIndex < dropIndex) {
            if (selectedlocomotives && selectedlocomotives.length > 1) {
                alertIndex = this.prepareAlertIndex(arrItems, selectedlocomotives);
                newArrayItems = this.multiShiftLeftToRight(dragIndex, dropIndex, arrItems, selectedlocomotives, alertIndex);
            } else {
                newArrayItems = this.shiftLeftToRight(dragIndex, dropIndex, arrItems);
            }
        } else if (dragIndex > dropIndex) {
            if (selectedlocomotives && selectedlocomotives.length > 1) {
                alertIndex = this.prepareAlertIndex(arrItems, selectedlocomotives);
                newArrayItems = this.multiRightToLeft(dragIndex, dropIndex, arrItems, selectedlocomotives, alertIndex);
            } else {
                newArrayItems = this.shiftRightToLeft(dragIndex, dropIndex, arrItems);
            }
        }
        this.printArrayTemp(newArrayItems);
        return newArrayItems;
    }

    /**
     * @private
     * @param {any} arrItems
     * @param {any} selectedLocomotives
     * @returns
     *
     * @memberOf UtilService
     */
    private prepareAlertIndex(arrItems, selectedLocomotives) {
        const tempAlerts = [];
        for (let i = 0; i < arrItems.length; i++) {
            for (let j = 0; j < selectedLocomotives.length; j++) {
                if (arrItems[i].locomotiveIdentifier === selectedLocomotives[j].locomotiveIdentifier) {
                    tempAlerts.push(i);
                }
            }
        }
        return tempAlerts;
    }

    /**
     * @param {any} dragIndex
     * @param {any} dropIndex
     * @param {any} arrItems
     * @returns
     *
     * @memberOf UtilService
     */
    exchangeItems(dragIndex, dropIndex, arrItems) {
        const tempItem = arrItems[dragIndex];
        arrItems[dragIndex] = arrItems[dropIndex];
        arrItems[dropIndex] = tempItem;
        return arrItems;
    }

    /**
     * @param {any} arr
     *
     * @memberOf UtilService
     */
    printArrayTemp(arr) {
        const tempArr = [];
        for (let i = 0; i < arr.length; i++) {
            tempArr.push(arr[i].locomotiveIdentifier);
        }
    }

    /**
     * @param {any} dragIndex
     * @param {any} dropIndex
     * @param {any} arrItems
     * @returns
     *
     * @memberOf UtilService
     */
    shiftLeftToRight(dragIndex, dropIndex, arrItems) {
        const temp = [];
        let tempItem;

        for (let i = 0; i < arrItems.length; i++) {
            if (i === dragIndex) {
                tempItem = arrItems[dragIndex];
            }
            if (i === (dropIndex)) {
                temp.push(arrItems[i]);
                temp.push(tempItem);
            } else if (i !== dragIndex) {
                temp.push(arrItems[i]);
            }
        }
        return temp;
    }

    /**
     * @param {any} dragIndex
     * @param {any} dropIndex
     * @param {any} arrItems
     * @param {any} movedArr
     * @param {any} alertIndex
     * @returns
     *
     * @memberOf UtilService
     */
    multiShiftLeftToRight(dragIndex, dropIndex, arrItems, movedArr, alertIndex) {
        const temp = [];
        for (let i = 0; i < arrItems.length; i++) {
            if (i === dropIndex) {
                if (!this.isPresentInAlertIndex(alertIndex, i)) {
                    temp.push(arrItems[i]);
                }
                for (let j = 0; j < movedArr.length; j++) {
                    temp.push(movedArr[j]);
                }
            } else if (this.isPresentInAlertIndex(alertIndex, i)) {
                // Do nothing or skip these elemets
            } else if (!this.isPresentInAlertIndex(alertIndex, i)) {
                temp.push(arrItems[i]);
            }
        }
        return temp;

    }

    /**
     * @private
     * @param {number[]} alertIndex
     * @param {number} index
     * @returns
     *
     * @memberOf UtilService
     */
    private isPresentInAlertIndex(alertIndex: number[], index: number) {
        let returnValue = false;
        alertIndex.forEach((myIndex) => {
            if (myIndex === index) {
                returnValue = true;
            }
        });
        return returnValue;
    }

    /**
     * @param {any} dragIndex
     * @param {any} dropIndex
     * @param {any} arrItems
     * @returns
     *
     * @memberOf UtilService
     */
    shiftRightToLeft(dragIndex, dropIndex, arrItems) {
        const temp = [];
        let shiftFlag = false;
        for (let i = 0; i < arrItems.length; i++) {
            if (i === dropIndex) {
                temp.push(arrItems[dragIndex]);
                shiftFlag = true;
            } else if (i === dragIndex) {
                temp.push(arrItems[i - 1]);
                shiftFlag = false;
            } else if (shiftFlag) {
                temp.push(arrItems[i - 1]);
            } else {
                temp.push(arrItems[i]);
            }
        }
        return temp;
    }

    /**
     * @private
     * @param {any} dragIndex
     * @param {any} dropIndex
     * @param {any} arrItems
     * @param {any} selectedlocomotives
     * @param {any} alertIndex
     * @returns
     *
     * @memberOf UtilService
     */
    private multiRightToLeft(dragIndex, dropIndex, arrItems, selectedlocomotives, alertIndex) {
        const temp = [];
        for (let i = 0; i < arrItems.length; i++) {
            if (i === dropIndex) {
                for (let j = 0; j < selectedlocomotives.length; j++) {
                    temp.push(selectedlocomotives[j]);
                }
                if (!this.isPresentInAlertIndex(alertIndex, i)) {
                    temp.push(arrItems[i]);
                }
            } else if (this.isPresentInAlertIndex(alertIndex, i)) {
                // Do nothing or skip these elemets
            } else if (!this.isPresentInAlertIndex(alertIndex, i)) {
                temp.push(arrItems[i]);
            }
        }
        return temp;
    }

    /**
     * @param {any} ArrCollection
     * @returns
     *
     * @memberOf UtilService
     */
    removeUndefinedInArray(ArrCollection) {
        const arrLength = ArrCollection.length;

        for (let j = arrLength - 1; j >= 0; j--) {
            if (typeof ArrCollection[j] === 'undefined' || _.isUndefined(ArrCollection[j])) {
                ArrCollection.splice(j, 1);
            }
        }
        return ArrCollection;
    }
}
